export enum Milestone {
  INITIAL = 'INITIAL',
  REQUESTED = 'REQUESTED',
  APPROVED = 'APPROVED',
  CONFIRMED = 'CONFIRMED',
  PAID = 'PAID',
}
